import { filter, includes, sortBy } from 'lodash/fp';

import constants from '../../../../../../../../../ahm-constants';
import getSaleableProductIds from '../../../../../../../../../utils/get-saleable-product-ids';

const panelsByProductType = {
  [constants.PRODUCT_TYPE.PACKAGE]: {
    heading: 'Hospital and extras packages',
    productIds: [
      constants.PRODUCT.LITE_FLEXI_BRONZE_PLUS_EXCESS_750,
      constants.PRODUCT.CLASSIC_FLEXI_SILVER_PLUS_EXCESS_750,
      constants.PRODUCT.DELUXE_FLEXI_SILVER_PLUS_EXCESS_750,
    ],
  },
  [constants.PRODUCT_TYPE.EXTRAS]: {
    hasTwoLineName: true,
    heading: 'Extras only',
    productIds: [
      constants.PRODUCT.BLACK_50_SAVER_EXTRAS,
      constants.PRODUCT.BLACK_60_EXTRAS,
      constants.PRODUCT.BLACK_70_BOOST_EXTRAS,
      constants.PRODUCT.BLACK_70_EXTRAS,
      constants.PRODUCT.FAMILY_EXTRAS,
      constants.PRODUCT.LIFESTYLE_EXTRAS,
      constants.PRODUCT.SUPER_EXTRAS,
      constants.PRODUCT.VALUE_EXTRAS,
    ],
  },
};

// @ts-expect-error - Automatic, Please fix when editing this file
const filterProducts = ({ productType, products }) => {
  // @ts-expect-error - Automatic, Please fix when editing this file
  const { productIds } = panelsByProductType[productType];
  const saleableProductIds = getSaleableProductIds();
  return sortBy(
    'rank',
    filter((product) => includes(product.id, productIds) && includes(product.id, saleableProductIds), products),
  );
};

export default filterProducts;
